import { useContext } from 'react'
import { CtaContext, ICtaContext } from '../contexts/cta-provider/CtaProvider'

export const useCtaContext = (): ICtaContext => {
  const cardContext = useContext(CtaContext)

  return cardContext
}
